import http from 'apis/config/http-service';
import { useCallback } from 'react';
import { SupplierStatementDto } from './use-get-supplier-statements-api';

const endpoint = 'ums/v1/cms/bnpl/supplier-statements';

type TOption = {
  value: number;
  label: string;
};

export function useSearchSupplierStatementsApi() {
  const loadOptions = useCallback(
    (facilityId: number) => (_inputValue: string, callback: (options: TOption[]) => void) => {
      if (!facilityId) {
        callback([]);
        return;
      }

      http
        .get(endpoint, {
          params: {
            facilityId,
            page: 1,
            limit: 20,
          },
        })
        .then((res) => {
          const options: TOption[] = (res?.data?.data || []).map((item: SupplierStatementDto) => ({
            value: item.id,
            label: `#${item.id}${item.statementRef ? ` — ${item.statementRef}` : ''} — ${item.statementAmount} AED — ${item.periodStart} to ${item.periodEnd}`,
          }));
          callback(options);
        })
        .catch(() => callback([]));
    },
    []
  );

  return { loadOptions };
}
